export enum CampaignFilterType {
    SEARCH_TERM = 'searchTerm',
    BROADCAST_STATUS = 'broadcastStatus',
    CHANNEL = 'channel',
    TEMPLATE = 'template'
}